import { RANGE_FILTER } from '@as-react/common-types';
import { createSelector } from 'reselect';
const getActiveFilters = (state) => state.activeFilters;
export const makeGetFlattenedActiveFiltersState = () => createSelector([getActiveFilters], (activeFilters) => {
    return (!!activeFilters &&
        Object.keys(activeFilters).reduce((arr, filterOn) => {
            const activeFilter = activeFilters[filterOn];
            let result = [];
            if (activeFilter.filterType === RANGE_FILTER) {
                result = [
                    {
                        filterContentType: activeFilter.filterContentType,
                        filterOn: filterOn,
                        filterOnName: activeFilter.filterOnName,
                        filterType: activeFilter.filterType,
                        filterPrefix: activeFilter.filterPrefix,
                        filterSuffix: activeFilter.filterSuffix,
                        rangeMin: activeFilter.rangeMin,
                        rangeMax: activeFilter.rangeMax,
                    },
                ];
            }
            else {
                if (activeFilter.values) {
                    result = activeFilter.values.map(activeFilterValue => ({
                        filterContentType: activeFilter.filterContentType,
                        filterKey: activeFilterValue.filterKey,
                        filterKeyName: activeFilterValue.filterKeyName,
                        filterOn: filterOn,
                        filterType: activeFilter.filterType,
                        filterOnName: activeFilter.filterOnName,
                        queryParamKey: activeFilter.queryParamKey,
                    }));
                }
            }
            return arr.concat(result);
        }, [])) || [];
});
export const makeGetActiveFilters = () => createSelector([getActiveFilters], (activeFilters) => activeFilters);
